import TransitVisaIcon from '@/src/assets/svgs/TransitVisaIcon'
import { Box, SxProps, Theme, Tooltip, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

export const TransitVisaIndicator = ({ sx }: { sx?: SxProps<Theme> }) => {
    const t = useTranslations('common')
    return (
        <Tooltip
            title={
                <Box>
                    <Typography fontWeight={600} color="inherit" fontSize="12px">
                        {t('transitVisa')}
                    </Typography>
                    <Typography color="inherit" sx={{ mt: 0.5 }} fontWeight={400} fontSize="10px">
                        {t('transitVisaMayBeRequired')}
                    </Typography>
                </Box>
            }
            placement="top"
        >
            <Box sx={{ display: 'inline-flex', cursor: 'help', color: 'grey.600', ...sx }}>
                <TransitVisaIcon color="inherit" sx={{ fontSize: 16 }} />
            </Box>
        </Tooltip>
    )
}

export default TransitVisaIndicator
